// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2O_1P","signatureBlock":"Footer_signatureBlock__v0dzx","signature":"Footer_signature__1uSxl"};